import { withAuthenticationRequired as withAuthenticationRequiredAuth0 } from "@auth0/auth0-react";
import { withPermissions } from "../features/permissions/components/auth-guard";

type WithAuthenticationRequiredAuth0 = typeof withAuthenticationRequiredAuth0;

const withAuthenticationRequired: WithAuthenticationRequiredAuth0 = (
  Component,
  options,
) => withAuthenticationRequiredAuth0(withPermissions(Component), options);

export default withAuthenticationRequired;
